module.exports = __webpack_public_path__ + "img/6.9288329e.png";